"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        flexGrow: 0,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        opacity: 1,
        transition: 'opacity 250ms linear 250ms',
        '&[aria-busy="true"]': {
            opacity: 0
        }
    },
    primary: {
        order: 1,
        marginRight: 21
    },
    secondary: {
        order: 3,
        justifyContent: 'flex-end',
        '&:only-child': {
            width: '100%'
        }
    },
    tertiary: {
        flexGrow: 1,
        order: 2,
        marginRight: 21,
        justifyContent: 'center',
        flexShrink: 1
    }
});
//# sourceMappingURL=header.section.style.js.map